import { Locale, Section } from "./models";
import { addEnviromentToHref } from "./utils/enviroments-url";

export class MainConfig {
  apiUrl: string;
  webUrl: string;
  authTokenName: string = "token";
  localesAvailable: Array<Locale> = [];
  defaultLocaleCode: string;
  cmsName: string;
  topBarLogo: string;
  topBarLogoHeight: string;
  mainMenuSections: Array<Section> = [];
  modules: any;
  store: string | false;

  constructor(options: MainConfig) {
    Object.assign(this, options);

    this.apiUrl = addEnviromentToHref(this.apiUrl);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/main-config.ts